export const emptyPaginationSx = {
    root: {
        gap:'6px'
    },
    button: {
        border: '1px solid #0000003b',
        width: '32px',
        height: '30px',
        '.darkTheme &':{
            border: '1px solid rgba(255,255,255,.5)',
        }
    },
    page: {
        border: '1px solid #0000003b',
        width: '40px',
        height: '30px',
        '.darkTheme &':{
            border: '1px solid rgba(255,255,255,.5)',
        }
    },
    pageCount:{
        '.lightTheme &':{
            color:'#000'
        }

    }
}